import React from 'react';

import BlogPostCard from './BlogPostCard';



const FeaturedSection = ({ featuredPosts, onReadMore }) => {

  if (!featuredPosts || featuredPosts?.length === 0) {

    return null;

  }



  return (

    <section className="mb-8 md:mb-12">

      <div className="flex items-center space-x-3 mb-4 md:mb-6">

        <div className="w-1 h-8 bg-accent rounded-full"></div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">

          Featured Articles

        </h2>

      </div>

      <div className="grid grid-cols-1 gap-6 md:gap-8">

        {featuredPosts?.map((post) => (

          <BlogPostCard

            key={post?.id}

            post={post}

            onReadMore={onReadMore}

            featured={true}

          />

        ))}

      </div>

    </section>

  );

};



export default FeaturedSection;